import { RoleUserManagementModalProvider } from '@user-management/role-user-management';
import { useParams } from '@user-management/router';
import { Outlet } from 'react-router-dom';

export default function RoleAndPermissionDetailsLayout() {
  const { appRoleId } = useParams('/roles-and-permissions/:appRoleId');

  return (
    <RoleUserManagementModalProvider appRoleId={appRoleId}>
      <Outlet />
    </RoleUserManagementModalProvider>
  );
}
